import React /*, { useGlobal } */ from 'reactn';
import moment from 'moment';

// import { devOrProd } from '../shared/utils';

const DeliveryEstimates = () => {
  // const [globalState] = useGlobal();

  /* DELIVERY ESTIMATES */
  // Current Day
  const currentDay = moment();

  //Current Hour
  const currentHour = currentDay.hour();

  // Next Day Message
  const nextDayDelivery = moment().add(1, 'day').format('ddd D MMM');

  // Standard Message - Start - 2 days
  const standardStartDelivery2 = moment().add(2, 'day').format('ddd D MMM');

  // Standard Message - Start - 3 days
  const standardStartDelivery3 = moment().add(3, 'day').format('ddd D MMM');

  // Standard Message - End - 4 days
  const standardEndDelivery4 = moment().add(4, 'day').format('ddd D MMM');

  // Standard Message - End - 5 days
  const standardEndDelivery5 = moment().add(5, 'day').format('ddd D MMM');

  // 2 - 4 Days - Standard Delivery
  // Start Sunday
  const standardStartSun = moment().day('Sunday').hour(0).minute(0).second(1);
  // End Tuesday
  const standardEndTue = moment().day('Tuesday').hour(23).minute(59).second(59);

  // 2 - 5 Days - Standard Delivery
  // Start Wednesday
  const standardStartWed = moment()
    .day('Wednesday')
    .hour(0)
    .minute(0)
    .second(1);
  // End Thursday
  const standardEndThu = moment()
    .day('Thursday')
    .hour(23)
    .minute(59)
    .second(59);

  // 3 - 5 Days - Standard Delivery
  // Start Friday
  const standardStartFri = moment().day('Fri').hour(0).minute(0).second(1);
  // End Saturday
  const standardEndSat = moment()
    .day('Saturday')
    .hour(23)
    .minute(59)
    .second(59);

  // Next Day - Sunday
  /*
    const startSun = moment()
      .day('Sunday')
      .hour(0)
      .minute(1)
      .second(0);
    const endSun = moment()
      .day('Sunday')
      .hour(23)
      .minute(0)
      .second(0);
  */

  // Next Day - Monday
  const startMon = moment().day('Monday').hour(0).minute(1).second(0);
  const endMon = moment().day('Monday').hour(22).minute(0).second(0);

  // Next Day - Tuesday
  const startTue = moment().day('Tuesday').hour(0).minute(1).second(0);
  const endTue = moment().day('Tuesday').hour(22).minute(0).second(0);

  // Next Day - Wednesday
  const startWed = moment().day('Wednesday').hour(0).minute(1).second(0);
  const endWed = moment().day('Wednesday').hour(22).minute(0).second(0);

  // Next Day - Thursday
  const startThu = moment().day('Thursday').hour(0).minute(1).second(0);
  const endThu = moment().day('Thursday').hour(22).minute(0).second(0);

  const NextDayDel = () => {
    return currentDay.isBetween(startMon, endMon) ||
      currentDay.isBetween(startTue, endTue) ||
      currentDay.isBetween(startWed, endWed) ||
      (currentDay.isBetween(startThu, endThu) && currentHour < 17) ? (
      <div
        id="delivery-estimates-container"
        className="flex flex-col gap-2.5 m-0 text-left"
      >
        <div className="flex items-center w-full gap-4">
          <PulseDot />
          <p className="text-[13px] tracking-wide lg:text-base lg:tracking-wider">
            <span className="font-bold inline">
              Order with Express Delivery
            </span>{' '}
            <span>get it</span>{' '}
            <span className="text-[#000]">
              {nextDayDelivery.toString()} - {standardStartDelivery2.toString()}
            </span>
          </p>
        </div>
      </div>
    ) : null;
  };

  const standardTemplate = (standardStartProp, standardEndProp) => {
    return (
      <div id="delivery-estimates-container">
        <div className="delivery-estimates">
          <div className="flex items-center w-full gap-4">
            <PulseDot />
            <p className="text-[13px] tracking-wide lg:text-base lg:tracking-wider">
              <span className="font-bold">Order with Standard Delivery</span>{' '}
              <span>get it</span>{' '}
              <span className="text-[#000]">
                {standardStartProp.toString()}
                {' - '}
                {standardEndProp.toString()}
              </span>
            </p>
          </div>
        </div>
      </div>
    );
  };

  const PulseDot = () => (
    <div className="relative w-[12px] h-[12px]">
      <div className="absolute w-[8px] h-[8px] z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#FEDB5E]"></div>
      <div className="animate-ping origin-center rounded-full w-[12px] h-[12px] bg-[#FEDB5E]"></div>
    </div>
  );

  const StandardDel = () => {
    return currentDay.isBetween(standardStartSun, standardEndTue)
      ? standardTemplate(standardStartDelivery2, standardEndDelivery4)
      : currentDay.isBetween(standardStartWed, standardEndThu)
      ? standardTemplate(standardStartDelivery2, standardEndDelivery5)
      : currentDay.isBetween(standardStartFri, standardEndSat)
      ? standardTemplate(standardStartDelivery3, standardEndDelivery5)
      : null;
  };

  // if (devOrProd === 'prod') return null;

  return (
    <>
      <div className="!px-0 my-6 lg:my-10 flex flex-col gap-4">
        <NextDayDel />
        <StandardDel />
      </div>
    </>
  );
};

export default DeliveryEstimates;
